module.exports = __webpack_public_path__ + "img/Lobby_Banner3.fb78f382.png";